import useContract from './useContract';
import IRainbows from '../contracts/IRainbows.json';

const useRainbows = () =>
  useContract(process.env.NEXT_PUBLIC_RAINBOWS_CONTRACT_ADDRESS, IRainbows.abi);

export default useRainbows;
